var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './style.css';
const experienceChoice = document.getElementById('experience-choice');
const fullExperienceButton = document.getElementById('start-full-experience');
let applicationStarted = false;
const startFullExperience = () => __awaiter(void 0, void 0, void 0, function* () {
    if (applicationStarted)
        return;
    applicationStarted = true;
    fullExperienceButton === null || fullExperienceButton === void 0 ? void 0 : fullExperienceButton.setAttribute('disabled', 'true');
    experienceChoice === null || experienceChoice === void 0 ? void 0 : experienceChoice.classList.add('experience-choice--leaving');
    const { default: Application } = yield import('./Application/Application');
    experienceChoice === null || experienceChoice === void 0 ? void 0 : experienceChoice.remove();
    new Application();
});
fullExperienceButton === null || fullExperienceButton === void 0 ? void 0 : fullExperienceButton.addEventListener('click', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('experience', 'full');
    window.history.replaceState({}, '', url.toString());
    void startFullExperience();
});
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('experience') === 'full' || urlParams.has('debug')) {
    void startFullExperience();
}
